import { EventEmitter, Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CallSocketService {
  private socket: Socket | null = null;
  private isConnected = false;
  ariCallEvent: EventEmitter<any> = new EventEmitter<any>();
  notificationCount: EventEmitter<any> = new EventEmitter<any>();
  constructor(private http: HttpClient) {}

  connect(userId?: string) {
    if (this.isConnected) return;

    this.socket = io(environment.socketUrl, {
      path: '/auth-sub/socket.io/',
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: 3,
    });

    this.socket.on('connect', () => {
      console.log('Socket connected:', this.socket?.id);
      this.isConnected = true;

      this.socket?.emit('user_connected', {
        userId: userId || 'unknown_user',
        socketId: this.socket?.id,
      });

      this.socket?.on('both_answer', (data) => {
        this.ariCallEvent.emit({ ...data, event_type: 'both_answer' });
      });

      this.socket?.on('hang_up', (data) => {
        this.ariCallEvent.emit({ ...data, event_type: 'hang_up' });
      });

      this.socket?.on('new_notification', (data) => {
        this.notificationCount.emit({
          ...data,
          event_type: 'new_notification',
        });
      });
    });

    this.socket.on('call_disconnected', () => {
      this.isConnected = false;
      console.log('SOCKET DISCONNECTED');
    });

    this.socket.on('connect_error', (err) => {
      console.error('SOCKET ERROR:', err);
    });
  }

  disconnect() {
    this.socket?.disconnect();
    this.socket = null;
    this.isConnected = false;
  }

  disconnectSession() {
    this.socket?.emit('disconnect_session');
  }

  callStart(doctorNo: any, userNo: any) {
    return this.http.get<any>(
      `${environment.url}/api/connect?doctorNo=${doctorNo}&userNo=${userNo}`
    );
  }

  emit(event: string, payload: any) {
    if (this.socket?.connected) {
      this.socket.emit(event, payload);
    } else {
      console.log('Socket not connected');
    }
  }
}
